import { render, staticRenderFns } from "./developer.vue?vue&type=template&id=485b775a"
import script from "./developer.vue?vue&type=script&lang=js"
export * from "./developer.vue?vue&type=script&lang=js"
import style0 from "./developer.vue?vue&type=style&index=0&id=485b775a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports